import { render, staticRenderFns } from "./CreateAppointment.vue?vue&type=template&id=313996c8&scoped=true"
import script from "./CreateAppointment.vue?vue&type=script&lang=js"
export * from "./CreateAppointment.vue?vue&type=script&lang=js"
import style0 from "./CreateAppointment.vue?vue&type=style&index=0&id=313996c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313996c8",
  null
  
)

export default component.exports